module.exports = __webpack_public_path__ + "img/pain4.svg";